var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "hotkey",
          rawName: "v-hotkey",
          value: _vm.keymap,
          expression: "keymap"
        }
      ],
      staticStyle: { display: "flex", width: "100%" }
    },
    [
      _c("dialogue", {
        attrs: {
          title: "Are you sure?",
          paragraph: "This will move all items to box 1",
          button_names: ["Yes", "No"],
          show: _vm.box_dialogue
        },
        on: { dialogue: _vm.acceptEmpty, cancel: _vm.cancelEmpty }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "background-color": "rgb(224, 224, 224)",
            "padding-right": "16px"
          }
        },
        [
          _c("p", { staticClass: "title" }, [_vm._v("Box ID")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.boxNum,
                expression: "boxNum",
                modifiers: { lazy: true }
              }
            ],
            staticClass: "textfield",
            attrs: { tabindex: "1" },
            domProps: { value: _vm.boxNum },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.changeBox.apply(null, arguments)
              },
              blur: _vm.changeBox,
              change: function($event) {
                _vm.boxNum = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("button", { on: { click: _vm.emptyBox } }, [_vm._v("Empty Box")]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [_vm._v("Scan Item")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.scanText,
                expression: "scanText"
              }
            ],
            staticClass: "textfield",
            attrs: { id: "scanText", tabindex: "2" },
            domProps: { value: _vm.scanText },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.addItem.apply(null, arguments)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.scanText = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("button", { on: { click: _vm.addItem } }, [_vm._v("Add Item")])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { flex: "1", height: "calc(100vh - 50px)" } },
        [
          _c("layout-1", {
            key: _vm.updateKey,
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              table_name: "Box " + _vm.boxNum + " Items",
              filter_options: null,
              id: _vm.pageid4,
              searchbar: false,
              navbar: false,
              term: _vm.boxNum,
              usePages: false
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69eeda08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69eeda08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Edit_Box_Items.vue
// module id = 732
// module chunks = 0